import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { Link } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import background1 from "./image10.jpg";
import background2 from "./pic4.jpg";
import background3 from "./pic1.jpg";
import background4 from "./pic2.jpg";
import MovieList from "../component/movieList/movieList";
import "./home.css"; // Create a separate CSS file for additional styling if needed

const Home = () => {
    const [popularMovies, setPopularMovies] = useState([]);

    useEffect(() => {
        fetch(
            "https://api.themoviedb.org/3/movie/popular?api_key=4e44d9029b1270a757cddc766a1bcb63&language=en-US"
        )
            .then((res) => res.json())
            .then((data) => setPopularMovies(data.results));
    }, []);

    return (
        <div className="home-container">
            {/* Background Image Slider Section */}
            <div className="background-slider">
                <Carousel
                    showThumbs={false}
                    autoPlay={true}
                    infiniteLoop={true}
                    showStatus={false}
                    className="responsive-carousel"
                >
                    {/* Add background slider images */}
                    <div>
                        <img src={background1} alt="Background Slide 1" />
                    </div>
                    <div>
                        <img src={background2} alt="Background Slide 2" />
                    </div>
                    <div>
                        <img src={background3} alt="Background Slide 3" />
                    </div>
                    <div>
                        <img src={background4} alt="Background Slide 4" />
                    </div>
                    {/* Add more background slider images as needed */}
                </Carousel>
            </div>

            {/* Carousel Section */}
            <div className="carousel-section">
                <Carousel
                    showThumbs={false}
                    autoPlay={true}
                    transitionTime={1}
                    infiniteLoop={true}
                    showStatus={false}
                    className="responsive-carousel"
                >
                    {popularMovies.map((movie) => (
                        <Link
                            key={movie.id}
                            className="carousel-link"
                            to={`/movie/${movie.id}`}
                        >
                            <div className="posterImage">
                                <img
                                    src={`https://image.tmdb.org/t/p/original${movie && movie.backdrop_path}`}
                                    alt={movie.original_title}
                                />
                                <div className="posterImage__overlay">
                                    <div className="posterImage__title">
                                        {movie ? movie.original_title : ""}
                                    </div>
                                    <div className="posterImage__description">
                                        {movie ? movie.overview : ""}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </Carousel>
            </div>

            {/* Movie List Section */}
            <div className="container">
                <MovieList />
            </div>
        </div>
    );
};

export default Home;
